import { render, staticRenderFns } from "./UserEditContactDetails.vue?vue&type=template&id=a369e0bc&"
import script from "./UserEditContactDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditContactDetails.vue?vue&type=style&index=0&id=a369e0bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports